export default {
  googleAuthorizeTerms: "Deze app wordt vanaf 10 maart 2023 niet meer ondersteund. Installeer onze nieuwe versie van {googleAppName}."
};

// @key: @#@"googleAuthorizeTerms"@#@ @source: @#@"This app will not be supported after Mar 10th, 2023. Please install our new version of {googleAppName}."@#@
